interface BriefSectionProps {
  title: string
  items: string[]
  dotColor: string
  bgColor?: string
}

export function BriefSection({ title, items, dotColor, bgColor }: BriefSectionProps) {
  if (!items || items.length === 0) return null

  return (
    <div
      style={{
        padding: bgColor ? '12px 14px' : '0',
        background: bgColor ?? 'transparent',
        borderRadius: bgColor ? '8px' : '0',
        marginBottom: '16px',
      }}
    >
      <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--color-text-muted)', marginBottom: '8px' }}>
        {title}
      </p>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {items.map((item, i) => (
          <li key={i} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: 'var(--color-text)', lineHeight: 1.5 }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: dotColor, flexShrink: 0, marginTop: '5px' }} />
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
